import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.match.js";
import _classCallCheck from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/createSuper";
import Protocol from './protocol';
import { parse } from './util/cookie';
/**
 * H5 JSBridge 通用库
 * @class H5JSBridge
 * @extends Protocol
 */

var H5JSBridge = /*#__PURE__*/function (_Protocol) {
  _inherits(H5JSBridge, _Protocol);

  var _super = _createSuper(H5JSBridge);

  function H5JSBridge() {
    _classCallCheck(this, H5JSBridge);

    return _super.apply(this, arguments);
  }

  _createClass(H5JSBridge, [{
    key: "openLogin",
    value: function openLogin() {
      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        type: ''
      };

      if (typeof param === 'string') {
        param = {
          type: param
        };
      } else if (Object.prototype.toString.call(param) !== '[object Object]') {
        param = {};
      }

      if (!param.url) {
        param.ru = location.href;
      }

      param.ru = param.url || location.href;
      location.href = "//film.qq.com/weixin/login.html?type=".concat(param.type, "&ru=").concat(encodeURIComponent(param.ru));
    }
  }, {
    key: "getMainUserInfo",
    value: function getMainUserInfo() {
      return _get(_getPrototypeOf(H5JSBridge.prototype), "getMainUserInfo", this).call(this, true);
    }
    /**
     * 获取指定账号类型用户信息
     * @param {Array} type - 类型数组
     */

  }, {
    key: "getUserInfo",
    value: function getUserInfo() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (type.indexOf('qq') < 0 && type.indexOf('wx') < 0) {
        // 不支持其他账号类型
        return Promise.reject(null);
      }

      return this.getMainUserInfo().then(function (res) {
        if (!res) return null;
        var userInfo = {};

        for (var i = 0; i < type.length; i++) {
          if (res.type === type[i]) {
            userInfo[type[i]] = res;
          } else {
            userInfo[type[i]] = null;
          }
        }

        return userInfo;
      });
    }
    /**
     * 获取指定类型用户 cookie
     * @param {Array} type - 类型数组
     */

  }, {
    key: "getCookie",
    value: function getCookie() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (type.indexOf('qq') < 0 && type.indexOf('wx') < 0) {
        // 不支持其他账号类型
        return Promise.reject(null);
      }

      var cookie = parse(document.cookie);
      var cookies = {};

      for (var i = 0; i < type.length; i++) {
        if (type[i] === 'wx' && cookie.appid && cookie.openid) {
          cookies.wx = {
            appid: cookie.appid,
            openid: cookie.openid,
            access_token: cookie.access_token,
            main_login: 'wx'
          };
        } else if (type[i] === 'qq') {
          cookies.qq = {
            uin: cookie.uin || cookie.luin,
            skey: cookie.skey,
            lskey: cookie.lskey || '',
            main_login: 'qq'
          };
        }
      }

      return cookies;
    }
    /**
     * 获取网络状态
     * @returns {String} "offline", "wifi", "2g", "3g", "4g", "other"
     */

  }, {
    key: "getNetworkState",
    value: function getNetworkState() {
      return new Promise(function (resolve) {
        var matchNetType = navigator.userAgent.match(/NetType\/(.*?)\s/i);

        if (matchNetType && matchNetType[1]) {
          resolve(matchNetType[1].toLowerCase());
        } else {
          resolve('other');
        }
      });
    }
    /**
     * 页面跳转
     * @param {String} url 
     */

  }, {
    key: "openUrl",
    value: function openUrl() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      location.href = url;
      return Promise.resolve();
    }
    /**
     * 页面跳转
     * @param {String} url 
     */

  }, {
    key: "openView",
    value: function openView() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return this.openUrl(url);
    }
  }]);

  return H5JSBridge;
}(Protocol);

export default new H5JSBridge();